var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "37.354px",
    height: "37.382px",
    viewBox: "13.583 7.688 37.354 37.382",
    enableBackground: "new 13.583 7.688 37.354 37.382",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1664A5",
    d: "M32.25,7.688c10.303-0.006,18.686,8.361,18.688,18.651c0.004,10.364-8.39,18.751-18.742,18.731 c-10.288-0.02-18.614-8.395-18.612-18.724C13.585,16.032,21.928,7.694,32.25,7.688 M27.807,31.08 c-1.611,1.303-3.512,1.604-5.606,1.814c2.503,2.18,5.237,2.924,8.203,2.211c5.276-1.267,8.501-4.758,9.917-9.914 c0.496-1.804,0.265-3.861,2.058-5.135c0.017-0.012,0.002-0.065,0.002-0.133c-0.456,0.045-0.916,0.09-1.45,0.143 c0.432-0.696,0.805-1.295,1.176-1.894c-1.554,0.755-2.736,0.415-4.103-0.321c-2.51-1.354-5.608,0.417-5.938,3.241 c-0.067,0.574-0.01,1.163-0.01,1.854c-3.531-0.503-6.528-1.899-8.9-4.621c-1.137,2.169-0.486,3.911,1.014,5.671 c-0.658-0.111-1.097-0.186-1.601-0.271c0.037,2.028,1.254,3.155,3.005,4.146c-0.668,0.099-1.01,0.147-1.362,0.201 C24.778,29.657,25.271,30.068,27.807,31.08"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.f955c37057e2095b8c197d5ee78a0b70.svg";
export { ForwardRef as ReactComponent };